/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { TextInput } from '@carbon/react';

import { CLUSTER_AUTHENTICATION } from 'utils/constants';

export function TenantId({ selectedCluster, tenantId, setTenantId }) {
  return (
    (selectedCluster?.authentication === CLUSTER_AUTHENTICATION.BEARER_TOKEN ||
      selectedCluster?.authentication === CLUSTER_AUTHENTICATION.CLIENT_CREDENTIALS) && (
      <>
        <TextInput
          id="tenant-id-input"
          type="text"
          labelText="Tenant ID (Optional)"
          value={tenantId}
          onChange={(e) => setTenantId(e.target.value)}
        />
      </>
    )
  );
}
